import { AuthorizedLayout } from 'components'
import { ROUTES_PATH } from 'config'
import { AccountManager, Account } from 'pages/accountManager'
import {
  ForgotPassword,
  ForgotPasswordReset,
  SignIn
} from 'pages/auth'
import { Assets } from 'pages/assets'
import { SystemUnderMaintenance } from 'pages/systemUnderMaintenance'
import { AuthorizedRoute } from './AuthorizedRoute'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider
} from 'react-router-dom'
import { Campaigns } from 'pages/campaigns'
import { NewPassword } from 'containers/Auth'

const isSystemUnderMaintenance =
  process.env.REACT_APP_IS_SYSTEM_UNDER_MAINTENANCE

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      {isSystemUnderMaintenance === 'true'
        ? (
          <Route>
            <Route path="/" element={<SystemUnderMaintenance />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        )
        : (
          <Route>
            <Route path={ROUTES_PATH.SIGNIN} element={<SignIn />} />
            <Route
              path={ROUTES_PATH.FORGOT_PASSWORD}
              element={<ForgotPassword />}
            />
            <Route
              path={ROUTES_PATH.FORGOT_PASSWORD_RESET}
              element={<ForgotPasswordReset />}
            />
            <Route
              path={ROUTES_PATH.NEW_PASSWORD}
              element={<NewPassword />}
            />
            <Route path={ROUTES_PATH.DASHBOARD} element={<AuthorizedLayout />}>
              <Route
                index
                element={
                  <AuthorizedRoute>
                    <AccountManager />
                  </AuthorizedRoute>
                }
              />
              <Route
                path="*"
                element={<Navigate to={ROUTES_PATH.ACCOUNT_MANAGER} replace />}
              />
              <Route
                path={ROUTES_PATH.ACCOUNT_MANAGER}
                element={
                  <AuthorizedRoute>
                    <AccountManager />
                  </AuthorizedRoute>
                }
              />
              <Route
                path={ROUTES_PATH.CAMPAIGNS}
                element={
                  <AuthorizedRoute>
                    <Campaigns />
                  </AuthorizedRoute>
                }
              />
              <Route
                path={`${ROUTES_PATH.CAMPAIGNS}/logs`}
                element={
                  <AuthorizedRoute>
                    <Campaigns />
                  </AuthorizedRoute>
                }
              />
              <Route
                path={ROUTES_PATH.ASSETS}
                element={
                  <AuthorizedRoute>
                    <Assets />
                  </AuthorizedRoute>
                }
              />
              <Route
                path={ROUTES_PATH.ACCOUNT_DETAILS}
                element={
                  <AuthorizedRoute>
                    <Account />
                  </AuthorizedRoute>
                }
              />
            </Route>
            <Route
              path="*"
              element={
                <AuthorizedRoute>
                  <AuthorizedLayout />
                </AuthorizedRoute>
              }
            ></Route>
          </Route>
        )}
    </Route>
  )
)

export const AppRoutes = (): JSX.Element => {
  return <RouterProvider router={router} />
}
